import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import useProcessingRequestLabelApi from "../../http/processingRequestLabel/api";
import {
  PackagingAndLabelTypeLabel,
  RequestPackagingAndLabel,
} from "../../http/processingRequestLabelsPackagings/types";
import useProcessingRequestPackagingApi from "../../http/processingRequestPackaging/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteLabelsAndPackagingsDialogProps = {
  requestId: number;
  item: RequestPackagingAndLabel;
  onClose: () => void;
};

const DeleteLabelsAndPackagingsDialog: FC<DeleteLabelsAndPackagingsDialogProps> = ({ requestId, item, onClose }) => {
  const processingRequestLabelApi = useProcessingRequestLabelApi();
  const processingRequestPackagingApi = useProcessingRequestPackagingApi();
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);

  const [isModalSubmitting, setIsModalSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={item?.type == PackagingAndLabelTypeLabel ? i18n.t.labels.delete : i18n.t.packagings.delete}
      isSubmitting={isModalSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: async () => {
            try {
              setIsModalSubmitting(true);
              if (item.type === PackagingAndLabelTypeLabel) {
                await processingRequestLabelApi.deleteRequestLabel(requestId, item.id);
              } else {
                await processingRequestPackagingApi.deleteRequestPackaging(requestId, item.id);
              }
              setIsModalSubmitting(false);
              onClose();
            } catch (e) {
              setIsModalSubmitting(false);
              dispatch(showErrorNotification(i18n, e));
            }
          },
        },
      ]}
    >
      {item?.type == PackagingAndLabelTypeLabel ? i18n.t.labels.questions.delete : i18n.t.packagings.questions.delete}
    </ModalDialog>
  );
};

export default DeleteLabelsAndPackagingsDialog;
